const ListHeader = [{
    name: 'title',
    value: 'nonuser_charge.case_name',
    sortable: true,
    width: 120,
}, {
    name: 'expense_type',
    value: 'nonuser_charge.expense_type',
    sortable: true,
    width: 80,
}, {
    name: 'amount',
    value: 'retrieval.rental_amount',
    sortable: true,
    width: 80,
}, {
    name: 'create_time',
    value: 'customer.create_time',
    sortable: true,
    width: 120,
}, {
    name: 'status',
    value: 'nonuser_charge.status',
    sortable: true,
    width: 80,
}];

export default ListHeader;
